import currencyFormatter from './currencyFormatter';

const getFormattedPrice = (price, currencyCode = 'USD', currencySymbol = '$', locale = 'en-US') => {
  if (typeof price !== 'number') {
    return '';
  }

  if (currencyCode) {
    return currencyFormatter(price, locale, currencyCode);
  }
  return `${currencySymbol || '$'}${price.toFixed(2)}`;
};

export default getFormattedPrice;
